/**
 * Whether this build makes the calls that text people (sign-in codes, booked
 * mission texts). A dev build against a real backend skips them — it would
 * text real phones from a laptop — unless VITE_SEND_SMS=1 says a mock answers
 * them (dev:mock, dev:all, e2e).
 */
export const SENDS_TEXTS =
  !import.meta.env.DEV || import.meta.env.VITE_SEND_SMS === "1";
